import Vue from 'vue';
import Ionic from '@ionic/vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faClock, faHotel, faPlaneDeparture, faSuitcase } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App.vue';
import router from './router';

import '@ionic/core/css/core.css';
import '@ionic/core/css/ionic.bundle.css';

library.add(faClock);
library.add(faHotel);
library.add(faPlaneDeparture);
library.add(faSuitcase);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Ionic);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
